import { MESSAGE_TYPES } from '@sv-support-sdk/utils/src/constants/chatMessages';
import { TicketResponse } from '@sv-support-sdk/chat-api/modules/ticket';

import { TThunk } from '../index';
import { addMessage, deleteMessageByType } from '../slices/messages';
import { ObjectStrings } from '../../types/commonTypes';
import { $l } from '../../locales';

const ticketError =
  (data: TicketResponse): TThunk =>
  (dispatch) => {
    const { localizationName = '', errors = '' } = data;

    const errorMsg = Array.isArray(errors) ? errors.join('\n') : errors;

    // @ts-expect-error not found locale
    const message = $l(localizationName) || errorMsg || $l('SOMETHING_WENT_WRONG');

    dispatch(deleteMessageByType(MESSAGE_TYPES.TICKET));
    dispatch(
      addMessage({
        type: MESSAGE_TYPES.NOTIFICATION,
        title: '',
        message,
        icon: '40--error',
      }),
    );
  };

export const createTicket =
  (data: ObjectStrings): TThunk =>
  async (dispatch, getState, api) => {
    try {
      const ticket = await api.ticket.createTicket(data);
      dispatch(deleteMessageByType(MESSAGE_TYPES.TICKET));
      if (ticket.errors) {
        dispatch(ticketError(ticket));
        return;
      }
      dispatch(
        addMessage({
          type: MESSAGE_TYPES.TICKET_CREATED,
          id: ticket.id,
          hash: ticket.hash,
        }),
      );
    } catch (err) {
      // @ts-expect-error not found response
      dispatch(ticketError(err?.response?.body?.[0]));
    }
  };
